import {component} from "bidello";
import {AbstractUI} from "./AbstractUI";
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';

export class ViewBackdrop extends component(AbstractUI){

    init(){


        this.fadeInTween = new TWEEN.Tween(this.domElement.style);
        this.fadeOutTween = new TWEEN.Tween(this.domElement.style);

    }

    fadeIn(){

        return this.fadeOutTween.to({opacity:0},500).start()


    }

    fadeOut (){

        return this.fadeInTween.to({opacity:1},500).start()

    }

    hide(){


        this.fadeInTween.to({opacity:1},1).start()

    }

    show (){

        this.fadeOutTween.to({opacity:0},10).start()

    }


}